export const listItemClassName =
  'h-10 px-4 flex items-center rounded-md transition-colors';
// NOTE: When deployed ANTD styles overwrite link default styling so have to repeat them here
export const linkClassName =
  'text-body hover:text-body focus:text-body hover:no-underline focus:no-underline focus:ring-2 focus:ring-primary ring-inset';
export const listItemActiveClassName = 'bg-neutral-500 dark:bg-neutral-800';
export const listItemHoverClassName =
  'hover:bg-neutral-500 dark:hover:bg-neutral-800';
